import { Controller } from "@hotwired/stimulus"

// UI-17: filters the staff tiles by name or position as the visitor types.
export default class extends Controller {
  static targets = ["search", "tile", "empty"]

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visible = 0

    this.tileTargets.forEach((tile) => {
      tile.hidden = query !== "" && !tile.dataset.search.includes(query)
      if (!tile.hidden) visible++
    })
    this.emptyTarget.hidden = visible > 0
  }

  ignore() {}
}
